import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import Divisions from "../components/site/Divisions";
import Mauritius from "../components/site/Mauritius";
import HowWeWork from "../components/site/HowWeWork";
import Brands from "../components/site/Brands";
import TradingProducts from "../components/site/TradingProducts";
import VietnamSourcingSection from "../components/site/VietnamSourcingSection";
import Destinations from "../components/site/Destinations";
import Network from "../components/site/Network";
import Trust from "../components/site/Trust";
import Testimonials from "../components/site/Testimonials";
import ContactSection from "../components/site/ContactSection";
import Footer from "../components/site/Footer";

export default function Home() {
    return (
        <div className="grain bg-navy-deep" data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Divisions />
                <Mauritius />
                <HowWeWork />
                <Brands />
                <TradingProducts />
                <VietnamSourcingSection />
                <Destinations />
                <Network />
                <Trust />
                <Testimonials />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}
